import { Progress } from '@/components/ui/progress';

interface ScenarioProgressBarProps {
  current: number;
  total: number;
}

export function ScenarioProgressBar({ current, total }: ScenarioProgressBarProps) {
  const percentage = total > 0 ? (current / total) * 100 : 0;

  return (
    <div className="space-y-1">
      <div className="flex items-center justify-between text-sm text-muted-foreground">
        <span>
          Decision {Math.min(current + 1, total)} of {total}
        </span>
        <span>{Math.round(percentage)}%</span>
      </div>
      <Progress value={percentage} className="h-2" aria-label={`Decision ${Math.min(current + 1, total)} of ${total}`} />
    </div>
  );
}
